import { Pipe, PipeTransform } from '@angular/core';
import {
  PermitsValidateEnum,
  PermitsValidateInfo,
} from '@qaroni-app/permits/types/permits-validate.enum';

@Pipe({
  name: 'permitsValidate',
  standalone: false,
})
export class PermitsValidatePipe implements PipeTransform {
  transform(value: PermitsValidateEnum): string | number {
    if (
      value !== null &&
      value !== undefined &&
      Object.prototype.hasOwnProperty.call(PermitsValidateInfo, value)
    ) {
      return PermitsValidateInfo[value].name;
    }

    return value;
  }
}
